import { CheckTRTCUserStatusBanned } from '@src/utils/api/trtc-api';
import { useCallback, useEffect, useState } from 'react';

export const useBanned = () => {
  const [loading, setLoading] = useState(true);
  const [isBanned, setIsBanned] = useState(false);

  const fetchIsBanned = useCallback(async () => {
    try {
      setLoading(true);
      const isBanned = await CheckTRTCUserStatusBanned();
      setIsBanned(!!isBanned)
    } catch (e) {
    }
    setLoading(false);
  }, [])
  
  useEffect(() => { fetchIsBanned() }, [fetchIsBanned])

  return { loading, isBanned };
}